import * as React from 'react';
import { EnergyEfficiencyGrade } from '@packages/common';
import { getPublicRuntimeConfig } from '@helpers/getPublicRuntimeConfig';

const ASSETS_URL = getPublicRuntimeConfig('ASSETS_URL');

export const EnergyRating: React.FC<{ energyEfficency: EnergyEfficiencyGrade }> = ({ energyEfficency }) => {
  const path = `${ASSETS_URL}/static/images/EnergyRating${energyEfficency}.svg`;
  return <img src={path} width="53" height="30" alt={energyEfficency}></img>;
};
